import * as Sentry from '@sentry/react'
import { RepeateOne } from 'iconsax-react'
import errorImageSrc from '../assets/images/error.svg'
import { Button } from 'primereact/button'
const ErrorFallback = ({
  message,
  error,
  resetErrorBoundary,
}: {
  message: string
  error?: boolean
  resetErrorBoundary?: () => void
}) => {
  return (
    <div
      role="alert"
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        padding: '1rem',
      }}
    >
      <img src={errorImageSrc} alt="Error image" />
      {/* <p>{message}</p> */}
      <p>
        <strong>Oops</strong>, we have unexpected application behavior.
      </p>
      <p>
        If you want to help us solve the problem, click
        <span onClick={() => Sentry.showReportDialog()}>
          <strong>here</strong>
        </span>
        and write what you did to cause this problem.
      </p>
      {/* <button
      type="button"
      onClick={async () => {
        Sentry.showReportDialog()
      }}
    >
      Report
    </button> */}
      <Button
        label="Try Again"
        className="p-button-rounded w-full"
        icon={
          <>
            <div
              className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
              style={{
                backgroundColor: '#fff',
              }}
            >
              {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
            </div>
            <RepeateOne
              color="#333"
              variant="Bold"
              className="icon-center"
              // className="p-button-icon p-c p-button-icon-right"
            />
          </>
        }
        onClick={() => {
          window.location.reload()
        }}
        style={{
          backgroundColor: '#333',
          color: '#fff',
        }}
      />
      {/* <Button>Try again</Button> */}
      {/* <pre>{error.message}</pre>
        <button onClick={resetErrorBoundary}>Try again</button> */}
    </div>
  )
}

export default ErrorFallback
